<template>
  <div>
    <h1>Footers</h1>
    <v-data-table
      :headers="headers"
      :items="computedFooters"
      :pagination.sync="pagination"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <v-btn :to="{name:'footer',params:{id:props.item.id}}" small>{{props.item.id}}</v-btn>
          </td>
          <td>
            <EntityZ :entity="props.item.user" v-if="props.item.user" format="system" />
            <span v-if="!props.item.user">{{props.item.userid}}</span>
          </td>
          <td>{{props.item.timestamp | formatDateTime}}</td>
          <td>
            <v-btn :to="{name:'footer',params:{id:props.item.id}, query:{clone:true}}" small>clone</v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import EntityZ from "@/components/link/EntityZ";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Footers",
  metaInfo() {
    return {
      title: "Footers",
      titleTemplate: "%s - Document - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: { EntityZ },
  computed: {
    computedFooters() {
      return this.footers.map(f => {
        const user = this.users ? this.users[f.userid] : undefined;
        return { ...f, user };
      });
    }
  },
  data() {
    return {
      footers: [],
      users: null,
      headers: [
        {
          text: "Id",
          value: "id"
        },
        {
          text: "User",
          value: "user.name"
        },
        {
          text: "Timestamp",
          value: "timestamp"
        },
        {
          text: " ",
          sortable: false
        }
      ],
      pagination: {
        rowsPerPage: -1,
        sortBy: "timestamp",
        descending: true
      }
    };
  },
  methods: {
    fetchFooters() {
      nbmlaw
        .get(`/cors/admin/document/footers`)
        .then(response => {
          // console.log(response.data);
          this.footers = response.data;
        })
        .catch(() => {});
    },
    fetchEntities() {
      nbmlaw
        .get(`/cors/admin/document/footers/users`)
        .then(response => {
          // console.log(response.data);
          this.users = response.data;
        })
        .catch(() => {});
    }
  },
  created() {
    this.fetchFooters();
    this.fetchEntities();
  }
};
</script>
